module.exports = __webpack_public_path__ + "static/OldMansJourney4-a157e0aba426d314d7fec86371c192f5.png";